export default {
  notificationChannels: 'Kanały powiadomień',
  userSubscription: 'Subskrypcje użytkowników',
};
